import { jsx as _jsx } from "react/jsx-runtime";
import { Box, unsafe_keyframes } from "@gemini/core";
import { LoaderIcon } from "@gemini/icons";
import { useTranslate } from "../../utils/useTranslate";
export const Loading = () => {
    const t = useTranslate();
    const spin = unsafe_keyframes({ to: { transform: "rotate(1turn)" } });
    return (_jsx(Box, { as: "main", flex: "1 0 auto", minHeight: "100vh", paddingBottom: "20vh", display: "grid", gridTemplateRows: "1fr", placeItems: "center", 
        /**
         * Announce the loading message to the user without interrupting other
         * announcements nor focusing the area. It works for the first load
         * of a client-side rendered app and for subsequent navigations.
         *
         * {@link https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/roles/alert_role MDN}
         * {@link https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-live MDN}
         */
        role: "alert", "aria-live": "assertive", children: _jsx(LoaderIcon, { "aria-label": t("loading"), color: "inherit", size: "sizing.24", animationName: spin, animationDuration: "unsafe_component.button.motionDuration.spinner", animationTimingFunction: "unsafe_component.button.motionEasing.spinner", animationIterationCount: "infinite" }) }));
};
